import { createAction, props } from '@ngrx/store';
import { CorporateDirectoryUser } from 'src/app/corporate-directory/models/corporate-directory-user.model';
import { InAppNotificationSentAlert } from 'src/app/in-app-notifications/models/in-app-notification-alert-data.model';
import { InAppNotificationFilter } from 'src/app/in-app-notifications/models/in-app-notification-filter.model';
import { InAppNotificationSettings } from 'src/app/in-app-notifications/models/in-app-notification-settings.model';
import { InAppNotificationType } from 'src/app/in-app-notifications/models/in-app-notification-type.enum';
import { InAppNotification } from 'src/app/in-app-notifications/models/in-app-notification.model';
import { UnreadInAppNotificationCounts } from 'src/app/in-app-notifications/models/unread-in-app-notification-counts.model';
import { KeyValuePair } from 'src/app/shared/models/key-value-pair.model';

export const getInAppNotifications = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Get In-App Notifications',
    props<{ filter: InAppNotificationFilter }>()
);
export const getInAppNotificationsSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notifications Success',
    props<{ inAppNotifications: InAppNotification[] }>()
);
export const getInAppNotificationsFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notifications Failure',
    props<{ error: string }>()
);

export const getUnreadInAppNotificationsCount = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Get Unread In-App Notifications Count'
);
export const getUnreadInAppNotificationsCountSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Get Unread In-App Notifications Count Success',
    props<{ unreadInAppNotificationCounts: UnreadInAppNotificationCounts }>()
);
export const getUnreadInAppNotificationsCountFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Get Unread In-App Notifications Count Failure',
    props<{ error: string }>()
);

export const getUnreadInAppNotificationsCountForDelegation = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Get Unread In-App Notifications Count For Delegation',
    props<{ userId: string }>()
);
export const getUnreadInAppNotificationsCountForDelegationSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Get Unread In-App Notifications Count Success For Delegation',
    props<{ unreadInAppNotificationCounts: UnreadInAppNotificationCounts }>()
);
export const getUnreadInAppNotificationsCountForDelegationFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Get Unread In-App Notifications Count Failure For Delegation',
    props<{ error: string }>()
);

export const clearInAppNotificationData = createAction('[IN-APP NOTIFICATIONS API] Clear In-App Notifications Data');

export const getInAppNotificationById = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Get In-App Notifications By Id',
    props<{ notificationId: number }>()
);
export const getInAppNotificationByIdSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notifications By Id Success',
    props<{ inAppNotification: InAppNotification }>()
);
export const getInAppNotificationByIdFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notifications By Id Failure',
    props<{ error: string }>()
);

export const updateInAppNotificationSettings = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Update In-App Notification Settings',
    props<{ notificationId: number; userId: string; settings: InAppNotificationSettings }>()
);
export const updateInAppNotificationSettingsSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Update In-App Notification Settings Success',
    props<{ message: string; userId: string }>()
);
export const updateInAppNotificationSettingsFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Update In-App Notification Settings Failure',
    props<{ error: string }>()
);

export const markAllAsRead = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Mark All In-App Notifications As Read',
    props<{ parentInAppNotificationTypeId: InAppNotificationType; userId: string }>()
);
export const markAllAsReadSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Mark All In-App Notifications As Read Success',
    props<{ message: string; userId: string }>()
);
export const markAllAsReadFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Mark All In-App Notifications As Read Failure',
    props<{ error: string }>()
);

export const inAppNotificationSentAlertSuccess = createAction(
    '[HUB CONNECTION SERVICE] In-App Notification Sent Alert Success',
    props<{ data: InAppNotificationSentAlert; userId: string }>()
);
export const inAppNotificationSentAlertFailure = createAction(
    '[HUB CONNECTION SERVICE] In-App Notification Sent Alert Failure',
    props<{ error: unknown }>()
);

export const resetState = createAction('[IN-APP NOTIFICATIONS LIST COMPONENT] Reset state when loading the list.');

export const noopAction = createAction(
    '[HUB CONNECTION SERVICE] Do nothing if In-App Notification Sent Alert is not intended for this app or login user'
);

export const getUnreadInAppNotificationsTabCounters = createAction(
    '[IN-APP NOTIFICATIONS TABS COMPONENT] Get Unread In-App Notifications Tab Counters',
    props<{ userId: string }>()
);
export const getUnreadInAppNotificationsTabCountersSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Get Unread In-App Notifications Tab Counters Success',
    props<{ unreadInAppNotificationsTabCounters: Array<KeyValuePair<InAppNotificationType, number>> }>()
);
export const getUnreadInAppNotificationsTabCountersFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Get Unread In-App Notifications Tab Counters Failure',
    props<{ error: string }>()
);

export const hasOverdueTasksCreatedByMe = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Has Overdue Tasks Created By Me'
);
export const hasOverdueTasksCreatedByMeSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Has Overdue Tasks Created By Me Success',
    props<{ hasOverdueTasksCreatedByMe: boolean }>()
);
export const hasOverdueTasksCreatedByMeFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Has Overdue Tasks Created By Me Failure',
    props<{ error: string }>()
);

export const getInAppNotificationsUser = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Get In-App Notifications User',
    props<{ userId: string }>()
);
export const getInAppNotificationsUserSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notifications User Success',
    props<{ user: CorporateDirectoryUser }>()
);
export const getInAppNotificationsUserFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notifications User Failure',
    props<{ error: string }>()
);
